var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 111,
    height: 111,
    rx: 10,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 25C39.5 25 27 37.5 27 53.5C27 69.5 55.5 95 55.5 95C55.5 95 84 69.5 84 53.5C84 37.5 71.5 25 55.5 25ZM55.5 62C51.5 62 48 58.5 48 54.5C48 50.5 51.5 47 55.5 47C59.5 47 63 50.5 63 54.5C63 58.5 59.5 62 55.5 62Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityImg);
export default __webpack_public_path__ + "static/media/activity-img.a0bcc4674e3be5f63193257703834569.svg";
export { ForwardRef as ReactComponent };